<template>
  <a-range-picker
      style="width: 100%"
      :format="widget.format"
      v-model:value="value"
      separator="-"
      :showTime="showTime"
      :disabled="info.status === 'show'"
      :allowClear="true"
      :ranges="ranges"
      :placeholder="[info.title + '开始', info.title + '结束']"
  />
</template>

<script lang="ts" setup>
import {computed, defineProps} from 'vue';
import {DateRangeSearch} from '@/components/business/crud/interface/SearchType';
import dayjs, {Dayjs} from 'dayjs';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";

const props = defineProps<{
  propName: string;
  widget: DateRangeSearch;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const ranges = {
  一天: [dayjs().subtract(1, 'd'), dayjs()],
  一周: [dayjs().subtract(1, 'w'), dayjs()],
  一个月: [dayjs().subtract(1, 'month'), dayjs()],
}
const showTime = {
    hideDisabledOptions: true,
    defaultValue: [
      dayjs('00:00:00', 'HH:mm:ss'),
      dayjs('23:59:59', 'HH:mm:ss'),
    ],
}
const value = computed({
  get() {
    const param: Dayjs[] = [];
    if (data.value[props.propName]?.$lte) {
      param.push(dayjs(Number(data.value[props.propName].$lte)));
    }
    if (data.value[props.propName]?.$gte) {
      param.push(dayjs(Number(data.value[props.propName].$gte)));
    }
    return param;
  },
  set(value: Dayjs[]) {
    const $gte = value ? value[0]?.valueOf() : undefined;
    const $lte = value ? value[1]?.valueOf() : undefined;
    if ($lte !== undefined || $gte !== undefined) {
      data.value[props.propName] = {
        $lte, $gte,
      }
    } else {
      data.value[props.propName] = undefined
    }
  },
})

</script>

<style lang="scss" scoped></style>
